
        import React from 'react';
        import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new SpriteSymbol({
  "id": "help.sprite",
  "use": "help.sprite-usage",
  "viewBox": "0 0 56 56",
  "content": "<symbol viewBox=\"0 0 56 56\" xmlns=\"http://www.w3.org/2000/svg\" id=\"help.sprite\">\n <path d=\"m25.67 42h4.667v-4.667h-4.667zm2.333-37.33c-12.88 0-23.33 10.45-23.33 23.33s10.45 23.33 23.33 23.33 23.33-10.45 23.33-23.33-10.45-23.33-23.33-23.33zm0 42c-10.29 0-18.67-8.377-18.67-18.67s8.377-18.67 18.67-18.67 18.67 8.377 18.67 18.67-8.377 18.67-18.67 18.67zm0-32.67c-5.157 0-9.333 4.177-9.333 9.333h4.667c0-2.567 2.1-4.667 4.667-4.667s4.667 2.1 4.667 4.667c0 4.667-7 4.083-7 11.67h4.667c0-5.25 7-5.833 7-11.67 0-5.157-4.177-9.333-9.333-9.333z\" fill-rule=\"evenodd\" />\n</symbol>"
});
        sprite.add(symbol);

        const HelpSpriteSpriteSymbol = props => (
            <svg {...props} viewBox='0 0 56 56'>
                <use xlinkHref='#help.sprite' />
            </svg>
        );
        export default HelpSpriteSpriteSymbol;
  